import { graphql } from 'gatsby';
import React from 'react';

import { RideQuery } from '../../../../graphql-types';
import { TPageProps } from '../../../page-props';
import RideDetailsPage from '../../../templates/ride-details';

export default (props: TPageProps<RideQuery>) => <RideDetailsPage {...props} />;

export const query = graphql`
  query Ride($id: Int, $withQuery: Boolean!) {
    ride(originalId: { eq: $id }) @include(if: $withQuery) {
      data {
        ...RideData
      }
    }
    allGeogroupWithRides {
      nodes {
        data {
          id
          partner {
            id
          }
        }
      }
    }
  }
`;
